<template>
  <div class="manual-modal" v-if="visible">
    <div class="manual-box">
      <button class="modal-close" @click="handleClose">✕</button>
      <h3 class="modal-title">操作手册</h3>
      
      <div class="manual-layout">
        <!-- 左侧导航 -->
        <div class="manual-nav">
          <!-- 工具使用说明 -->
          <div
            :class="['nav-item', 'intro-item', { active: showIntro }]"
            @click="showIntroduction"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="nav-icon">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
            </svg>
            <span>工具使用说明</span>
          </div>
          
          <div class="nav-divider"></div>
          
          <!-- 功能列表 -->
          <div
            v-for="(item, index) in manualItems"
            :key="index"
            :class="['nav-item', { active: !showIntro && activeIndex === index }]"
            @click="selectItem(index)"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="nav-icon">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon"/>
            </svg>
            <span>{{ item.title }}</span>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="manual-video">
          <!-- 显示工具使用说明 -->
          <div v-if="showIntro" class="intro-content">
            <p class="tip-highlight">💡 磨刀不误砍柴工，需要绘制什么图文，点击对应的手册，先查看视频演示</p>
            <h4>一、工具说明</h4>
            <p>我们知道，很多同学在写论文时都会遇到各种困难：</p>
            <p>不知道怎么画<strong>流程图</strong>、<strong>时序图</strong>，不会设计 <strong>ER 图</strong>，<strong>任务书</strong>和<strong>开题报告</strong>无从下手……</p>
            <p>为了这些事<strong>熬夜加班</strong>，甚至因论文进度<strong>焦虑到失眠</strong>。</p>
            <p><strong>故，天将降大任于斯人也</strong>——既然大家都这么辛苦，那不如<strong>让我们来扛一扛这份重担</strong>。</p>
            <p>于是我们自主开发了这个平台，希望能<strong>实实在在帮大家减轻一点负担</strong>。</p>
            <p>如果你觉得平台真的帮到了你，可以推荐给其他朋友使用 😊</p>
            <p>但也要坦白说：</p>
            <p>平台调用的大模型接口需要消耗 Token，而这些 Token 是我们<strong>自费购买</strong>的。</p>
            <p>如果积分使用完，还需要使用该工具，我们会<strong>象征性收取少量费用</strong>，</p> 
            <p><strong>仅用于覆盖基础成本，保障平台能够正常运营</strong>。</p>
            
            <h4>二、免责声明</h4>
            <p>本平台提供的所有工具和生成的内容仅供学习参考使用。用户在使用本平台服务时，应遵守以下条款：</p>
            <ul>
              <li>本平台生成的内容仅作为<span class="highlight">辅助工具</span>，主要用于提供<span class="highlight">思路参考</span>，<span class="highlight">不保证</span>完全准确性和适用性</li>
              <li>用户应对生成的内容进行<span class="highlight">审核和修改</span>，确保符合实际需求和学术规范</li>
              <li>用户需<span class="highlight">自行承担</span>使用本平台生成内容所产生的一切后果和责任</li>
              <li>本平台<span class="highlight">不对</span>因使用本服务而导致的任何直接或间接损失<span class="highlight">承担责任</span></li>
              <li>用户应遵守<span class="highlight">学术诚信原则</span>，<span class="highlight">不得</span>将生成内容直接用于学术不端行为</li>
            </ul>
            
            <h4>三、祝愿与服务</h4>
            <p>最后，衷心祝愿每一位同学都能<strong>顺利完成项目</strong>，<strong>答辩成功</strong>！</p>
            <p>希望这个平台能成为你学业路上的好帮手，让项目开发和论文写作不再是负担。</p>
            <p>如果你在项目开发过程中遇到了更复杂的问题，或者需要更深度的定制化服务，</p>
            <p>我们也提供<strong>专业的程序开发与技术支持服务</strong>，包括但不限于：</p>
            <ul>
              <li><strong>程序开发</strong>：Web应用、管理系统、小程序、APP等各类项目开发</li>
              <li><strong>系统设计</strong>：架构设计、技术选型、功能规划</li>
              <li><strong>数据库设计</strong>：表结构设计、ER图绘制、数据库建模</li>
              <li><strong>代码实现</strong>：功能开发、Bug修复、代码重构</li>
              <li><strong>论文辅导</strong>：技术文档撰写、论文图表设计、答辩PPT制作</li>
            </ul>
            <p>有需要的同学可以通过平台联系我们，我们会根据具体需求提供相应的帮助。</p>
          </div>
          
          <!-- 显示视频教程 -->
          <div v-if="!showIntro">
            <div class="video-header">
              <h4>{{ manualItems[activeIndex].title }}</h4>
              <p>{{ manualItems[activeIndex].desc }}</p>
            </div>
            <div class="video-container">
              <video
                v-if="manualItems[activeIndex].videoUrl"
                :src="manualItems[activeIndex].videoUrl"
                controls
                :key="activeIndex"
              >
                您的浏览器不支持视频播放
              </video>
              <div v-else class="video-placeholder">
                <i class="el-icon-video-camera"></i>
                <p>视频即将上线</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManualModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 每次打开模态框时重置为工具使用说明
        this.showIntro = true
        this.activeIndex = 0
      }
    }
  },
  data() {
    return {
      activeIndex: 0,
      showIntro: true,
      manualItems: [
        {
          title: '工具描述',
          icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
          desc: '观看平台工具功能介绍视频，快速了解各项功能的使用方法',
          videoUrl: 'https://geek-coding.cn/video/1.mp4'
        },
        {
          title: 'Draw.io使用',
          icon: 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
          desc: '学习如何使用Draw.io在线绘图工具，编辑和导出各类图表',
          videoUrl: 'https://geek-coding.cn/video/2.mp4'
        },
        {
          title: 'ER图/三线表生成',
          icon: 'M5 21h14v-5H5v5zM12 16v-5M12 11a3 3 0 100-6 3 3 0 000 6zM7 16l-3-6M4 10a2 2 0 100-4 2 2 0 000 4zM17 16l3-6M20 10a2 2 0 100-4 2 2 0 000 4z',
          desc: '输入SQL语句，自动生成ER图和三线表格式文档。注意：如果生成失败，可能是以下原因：1. 仅支持MySQL 8.x的SQL语法；2. SQL中存在乱码或多余的换行符。最好是删除掉SQL插入语句和其他的存储过程代码、触发器代码等等，不会操作的，可以联系我们帮忙操作',
          videoUrl: 'https://geek-coding.cn/video/3.mp4'
        },
        {
          title: '功能图',
          icon: 'M8 2h8v6H8zM12 8v3M3 11h18M3 11v6h6v-6H3zM9 11v6h6v-6H9zM15 11v6h6v-6h-6z',
          desc: '描述系统功能结构，生成功能模块层次图',
          videoUrl: 'https://geek-coding.cn/video/4.mp4'
        },
        {
          title: '用例图',
          icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
          desc: '输入系统角色和功能，自动生成UML用例图',
          videoUrl: 'https://geek-coding.cn/video/5.mp4'
        },
        {
          title: '流程图',
          icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
          desc: '描述业务流程，生成标准流程图',
          videoUrl: 'https://geek-coding.cn/video/6.mp4'
        },
        {
          title: '泳道图',
          icon: 'M4 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zM14 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z',
          desc: '展示跨部门或跨角色的业务流程，生成泳道图',
          videoUrl: 'https://geek-coding.cn/video/7.mp4'
        },
        {
          title: '时序图',
          icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
          desc: '描述对象间的交互顺序，生成UML时序图',
          videoUrl: 'https://geek-coding.cn/video/8.mp4'
        },
        {
          title: '任务书/开题报告',
          icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
          desc: '输入项目信息，自动生成规范的任务书和开题报告',
          videoUrl: 'https://geek-coding.cn/video/9.mp4'
        },
        {
          title: '文章生成',
          icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
          desc: '根据主题和要求，AI辅助生成学术文章内容',
          videoUrl: 'https://geek-coding.cn/video/10.mp4'
        },
        {
          title: '测试用例',
          icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
          desc: '输入功能需求，自动生成测试用例文档',
          videoUrl: 'https://geek-coding.cn/video/11.mp4'
        },
        {
          title: '降重降AIGC',
          icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
          desc: '对文本内容进行降重处理，降低AIGC检测率，提升内容原创性',
          videoUrl: 'https://geek-coding.cn/video/12.mp4'
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    selectItem(index) {
      this.activeIndex = index
      this.showIntro = false
    },
    showIntroduction() {
      this.showIntro = true
    }
  }
}
</script>

<style scoped>
.manual-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.manual-box {
  background: #fff;
  padding: 32px 40px;
  position: relative;
  max-width: 1200px;
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 18px;
  color: #9ca3af;
  cursor: pointer;
  z-index: 1;
}

.modal-close:hover {
  color: #374151;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 24px;
  text-align: center;
}

.manual-layout {
  display: flex;
  gap: 24px;
  flex: 1;
  min-height: 0;
}

/* 左侧导航 */
.manual-nav {
  width: 240px;
  flex-shrink: 0;
  overflow-y: auto;
  border-right: 1px solid #e5e7eb;
  padding-right: 16px;
  background: #f9fafb;
  margin-left: -40px;
  margin-top: -32px;
  margin-bottom: -32px;
  padding-left: 40px;
  padding-top: 32px;
  padding-bottom: 32px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  cursor: pointer;
  transition: all 0.2s;
  border-left: 3px solid transparent;
  margin-bottom: 4px;
}

.nav-item:hover {
  background: #f9fafb;
  border-left-color: #a5b4fc;
}

.nav-item.active {
  background: #eef2ff;
  border-left-color: #4f46e5;
  color: #4f46e5;
  font-weight: 600;
}

.nav-item i {
  font-size: 18px;
  flex-shrink: 0;
}

.nav-item.active i {
  color: #4f46e5;
}

.nav-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-item span {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.intro-item {
  background: #fef3c7;
  border-left-color: #f59e0b;
  font-weight: 600;
}

.intro-item:hover {
  background: #fde68a;
  border-left-color: #d97706;
}

.intro-item.active {
  background: #fef3c7;
  border-left-color: #f59e0b;
  color: #92400e;
}

.intro-item i {
  color: #f59e0b;
}

.intro-item .nav-icon {
  color: #f59e0b;
}

.nav-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 8px 0;
}

/* 右侧视频区域 */
.manual-video {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.video-header {
  margin-bottom: 16px;
}

.video-header h4 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
}

.video-header p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

.video-container {
  flex: 1;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.video-container video {
  width: 100%;
  height: 100%;
  max-height: 500px;
  object-fit: contain;
}

.video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #9ca3af;
}

.video-placeholder i {
  font-size: 64px;
}

.video-placeholder p {
  font-size: 16px;
  margin: 0;
}

/* 工具使用说明内容区域 */
.intro-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.intro-content h3 {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.intro-content h4 {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 8px;
  padding-bottom: 8px;
  border-bottom: 2px solid #4f46e5;
}

.intro-content p {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.8;
  margin: 8px 0;
}

.intro-content ul,
.intro-content ol {
  margin: 12px 0;
  padding-left: 24px;
}

.intro-content li {
  font-size: 14px;
  color: #374151;
  line-height: 1.8;
  margin: 8px 0;
}

.intro-content strong {
  color: #92400e;
  font-weight: 600;
}

.intro-content .highlight {
  color: #92400e;
  font-weight: 600;
}

.intro-content .tip-highlight {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 15px;
  color: #92400e;
  font-weight: 500;
  margin: 12px 0 16px;
  line-height: 1.6;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.1);
}

/* 滚动条样式 */
.manual-nav::-webkit-scrollbar {
  width: 6px;
}

.manual-nav::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.manual-nav::-webkit-scrollbar-thumb {
  background: #c7d2fe;
}

.manual-nav::-webkit-scrollbar-thumb:hover {
  background: #a5b4fc;
}
</style>
